var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "preload position-absolute", attrs: { id: "preload" } },
      [
        _c(
          "div",
          {
            staticClass: "row h-100 justify-content-center align-items-center",
          },
          [
            _c("div", { staticClass: "col-12 text-center" }, [
              _c("div", { staticClass: "ld ld-ring ld-spin-fast huge" }),
              _vm._v(" "),
              _c("h6", { staticClass: "mt-3 font-weight-s-bold" }),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }